<template>
  <div>
    <v-card class="pa-4 mb-3">
      <v-form
        v-model="valid"
        ref="form"
        lazy-validation
        class="pa-2"
        @submit.prevent="editUser"
        v-if="user"
      >
        <div class="d-flex justify-end">
          <v-btn
            tile
            color="primary"
            @click="$router.push({ name: 'user-index' })"
          >
            <v-icon left>
              arrow_back
            </v-icon>
            Back
          </v-btn>
        </div>
        <v-row class="text-center">
          <v-col class="text-center">
            <image-picker
              v-model="user.avatar"
              :uploaded="user.avatar !== null"
              @delete-item="user.avatar = null"
              @reset="user.avatar = null"
              class="mb-5"
            >
              <div slot="activator" class="cursor-pointer">
                <img
                  :src="user.avatar"
                  alt="avatar"
                  width="312px"
                  height="312px"
                  v-if="user.avatar"
                />
              </div>
            </image-picker>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col>
            <v-text-field
              :counter="35"
              label="Email"
              v-model="user.email"
              :rules="emailRules"
            ></v-text-field>

            <v-text-field
              :counter="35"
              label="First Name"
              v-model="user.firstName"
              :rules="nameRules"
            ></v-text-field>
            <v-autocomplete
              v-model="user.type"
              :items="types"
              :rules="typeRules"
              filled
              dense
              label="Select Types"
              item-text="name"
              item-value="id"
              required
            ></v-autocomplete>
            <v-row>
              <v-col>
                <v-autocomplete
                  v-model="user.supplierId"
                  :items="suppliers"
                  filled
                  dense
                  label="Select Supplier"
                  item-text="name"
                  item-value="id"
                  required
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-checkbox
              v-model="user.approved"
              label="Is Approved"
            ></v-checkbox>
            <v-checkbox v-model="user.active" label="Is Active"></v-checkbox>

            <v-btn type="submit" class="mx-0 mt-4">Update</v-btn>
          </v-col>

          <v-col>
            <v-text-field
              :counter="35"
              label="GCC Nummber"
              type="number"
              v-model="user.gccNumber"
              :rules="gccRules"
            ></v-text-field>

            <v-text-field
              :counter="20"
              label="Last Name"
              v-model="user.lastName"
              :rules="nameRules"
              required
            ></v-text-field>

            <v-autocomplete
              v-model="user.role"
              :items="roles"
              :rules="roleRules"
              filled
              dense
              label="Select Roles"
              item-text="name"
              item-value="id"
              required
            ></v-autocomplete>

            <v-autocomplete
              v-model="user.userPositionId"
              :items="userPositions"
              filled
              dense
              label="Select Position"
              item-text="name"
              item-value="id"
              required
            ></v-autocomplete>

            <v-autocomplete
              v-model="user.surgeryId"
              :items="surgeries"
              filled
              dense
              label="Select Surgery"
              item-text="name"
              item-value="id"
              required
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
    <address-list :payload="{ from: 0, to: 10, userId: id }" class="mb-3" />
    <phone-list :payload="{ from: 0, to: 10, userId: id }" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import AddressList from "@/components/user_management/address/AddressList.vue";
import PhoneList from "@/components/user_management/phone/PhoneList.vue";
import ImagePicker from "@/components/ImagePicker.vue";
export default {
  props: ["id"],
  data() {
    return {
      valid: false,
      types: ["employee", "owner"],
      roles: ["admin", "user"],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      nameRules: [
        v => !!v || "Name is required",
        v => v.length >= 3 || "Name must be at least 3 characters",
        v => v.length <= 35 || "Name must be less than than 35 characters"
      ],
      passwordRules: [
        v => !!v || "Password is required",
        v => v.length >= 6 || "Password must be at least 6 characters",
        v => v.length <= 15 || "Password must be less than than 15 characters"
      ],
      gccRules: [
        v => !!v || "GccNumber is required",
        v => v.length >= 8 || "Phone must be at least 8 digits",
        v => v.length <= 20 || "Phone must be less than than 20 digits"
      ],
      typeRules: [v => !!v || "Type is required"],
      roleRules: [v => !!v || "Role is required"]
    };
  },
  components: {
    AddressList,
    PhoneList,
    ImagePicker
  },
  async mounted() {
    await this.$store.dispatch("users/LOAD_USER_POSITIONS");
    await this.$store.dispatch("suppliers/LOAD_SUPPLIERS", {
      from: 0,
      to: 0
    });
    this.$store.dispatch("surgeries/LOAD_SURGERIES", {
      from: 0,
      to: 0
    });
    await this.$store.dispatch("users/LOAD_USER", {
      userId: this.id
    });
  },
  computed: {
    ...mapState({
      user: state => state.users.user,
      userPositions: state => state.users.user_positions,
      suppliers: state => state.suppliers.suppliers,
      surgeries: state => state.surgeries.surgeries
    })
  },
  methods: {
    async editUser() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Updating user...",
          html: "this will only take a moment",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("users/UPDATE_USER", this.user);
      }
    }
  }
};
</script>
